
import AOS from 'aos';

const init = () => {
    AOS.init({
        offset: 50,
        once: true
    });
};

const refresh = () => {
    AOS.refresh();
}

export default { init, refresh };
